<!--
 * @Description: 用户指南
 * @Author: zml
 * @Date: 2023-12-18 09:32:29
 * @LastEditors: zml
 * @LastEditTime: 2023-12-18 09:33:22
-->

<template>
  <div>
    <component :is="componentName"></component>
  </div>
</template>
<script>
import mixins from '@/utils/mixins'
export default {
  name: 'userGuide',
  mixins: [mixins],

  data() {
    return {
      componentName: ''
    }
  },
  created() {
    this.initDom()
  },
  methods: {
    initDom() {
      switch (this.$templates()) {
        case 'themeTemplateSeven':
          this.componentName = 'pageUserGuideSeven'
          break
        default:
          this.componentName = ''
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>